import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { AdditionalComponentPropsType } from "../CVComposition";

// functional component, which renders the cv parsing svg. Animation in active conditionally.

function CvParsingIcon(t0) {
  const $ = _c(146);
  const {
    animate
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g filter="url(#cvShadow)"><rect x="22" y="12" width="56" height="76" rx="2" fill="white" /><rect x="22.25" y="12.25" width="55.5" height="75.5" rx="1.75" stroke="#F4F4F4" strokeWidth="0.5" /></g>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = animate ? "#D2D6D9" : "#7D8996";
  let t3;
  if ($[1] !== animate) {
    t3 = animate && <animate attributeName="fill" from="#D2D6D9" to="#7D8996" begin="2000ms" dur="300ms" fill="freeze" repeatCount="1" />;
    $[1] = animate;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <circle cx="34" cy="24" r="8" fill={t2}>{t3}</circle>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== animate) {
    t5 = animate && <animate attributeName="opacity" from="0" to="1" begin="2000ms" dur="300ms" repeatCount="1" />;
    $[6] = animate;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <path fill="white" fillRule="evenodd" clipRule="evenodd" d="M29 31.2483C29.1017 27.7751 31.2997 25 33.9963 25C36.6929 25 38.8909 27.7751 38.9926 31.2483C37.6236 32.3445 35.8865 33 33.9963 33C32.1061 33 30.369 32.3445 29 31.2483Z">{t5}</path>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== animate) {
    t7 = animate && <animate attributeName="opacity" from="0" to="1" begin="2000ms" dur="300ms" repeatCount="1" />;
    $[10] = animate;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <circle cx="33.9963" cy="22" r="3" fill="white">{t7}</circle>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = animate ? "#D2D6D9" : "#B2CD0E";
  let t10;
  if ($[14] !== animate) {
    t10 = animate && <animate attributeName="fill" values="#D2D6D9; #B2CD0E" dur="300ms" begin="2900ms" repeatCount="1" fill="freeze" />;
    $[14] = animate;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <circle cx="29" cy="40" r="3" fill={t9} fillOpacity="0.8">{t10}</circle>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = animate ? "transparent" : "white";
  let t13;
  if ($[19] !== animate) {
    t13 = animate && <animate attributeName="opacity" values="0; 1" dur="200ms" begin="2900ms" repeatCount="1" opacity="freeze" />;
    $[19] = animate;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== animate) {
    t14 = animate && <animate attributeName="fill" values="#D2D6D9; white" dur="200ms" begin="2900ms" repeatCount="1" fill="freeze" />;
    $[21] = animate;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t12 || $[24] !== t13 || $[25] !== t14) {
    t15 = <path d="M31.125 38.6025L28.125 41.6025L26.75 40.2275L27.1025 39.875L28.125 40.895L30.7725 38.25L31.125 38.6025Z" fill={t12}>{t13}{t14}</path>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = animate ? "#D2D6D9" : "#B2CD0E";
  let t17;
  if ($[27] !== animate) {
    t17 = animate && <animate attributeName="fill" values="#D2D6D9; #B2CD0E" dur="300ms" begin="2900ms" repeatCount="1" fill="freeze" />;
    $[27] = animate;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <circle cx="29" cy="48" r="3" fill={t16} fillOpacity="0.8">{t17}</circle>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const t19 = animate ? "transparent" : "white";
  let t20;
  if ($[32] !== animate) {
    t20 = animate && <animate attributeName="opacity" values="0; 1" dur="200ms" begin="2900ms" repeatCount="1" opacity="freeze" />;
    $[32] = animate;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== animate) {
    t21 = animate && <animate attributeName="fill" values="#D2D6D9; white" dur="200ms" begin="2900ms" repeatCount="1" fill="freeze" />;
    $[34] = animate;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t19 || $[37] !== t20 || $[38] !== t21) {
    t22 = <path d="M31.125 46.6025L28.125 49.6025L26.75 48.2275L27.1025 47.875L28.125 48.895L30.7725 46.25L31.125 46.6025Z" fill={t19}>{t20}{t21}</path>;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  const t23 = animate ? "#D2D6D9" : "#B2CD0E";
  let t24;
  if ($[40] !== animate) {
    t24 = animate && <animate attributeName="fill" values="#D2D6D9; #B2CD0E" dur="300ms" begin="2900ms" repeatCount="1" fill="freeze" />;
    $[40] = animate;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23 || $[43] !== t24) {
    t25 = <circle cx="29" cy="56" r="3" fill={t23} fillOpacity="0.8">{t24}</circle>;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  const t26 = animate ? "transparent" : "white";
  let t27;
  if ($[45] !== animate) {
    t27 = animate && <animate attributeName="opacity" values="0; 1" dur="200ms" begin="2900ms" repeatCount="1" opacity="freeze" />;
    $[45] = animate;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== animate) {
    t28 = animate && <animate attributeName="fill" values="#D2D6D9; white" dur="200ms" begin="2900ms" repeatCount="1" fill="freeze" />;
    $[47] = animate;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t26 || $[50] !== t27 || $[51] !== t28) {
    t29 = <path d="M31.125 54.6025L28.125 57.6025L26.75 56.2275L27.1025 55.875L28.125 56.895L30.7725 54.25L31.125 54.6025Z" fill={t26}>{t27}{t28}</path>;
    $[49] = t26;
    $[50] = t27;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  let t31;
  let t32;
  let t33;
  let t34;
  let t35;
  let t36;
  let t37;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <rect x="47" y="17" width="14" height="4" rx="2" fill="url(#rect1)" />;
    t31 = <rect x="47" y="22" width="27" height="4" rx="2" fill="url(#rect2)" />;
    t32 = <rect x="47" y="27" width="25" height="4" rx="2" fill="url(#rect3)" />;
    t33 = <rect x="34" y="37" width="40" height="6" rx="2" fill="url(#rect4)" />;
    t34 = <rect x="34" y="45" width="40" height="6" rx="2" fill="url(#rect5)" />;
    t35 = <rect x="34" y="53" width="40" height="6" rx="2" fill="url(#rect6)" />;
    t36 = <rect x="26" y="63" width="48" height="12" rx="2" fill="url(#rect7)" />;
    t37 = <rect x="26" y="77" width="48" height="6" rx="2" fill="url(#rect8)" />;
    $[53] = t30;
    $[54] = t31;
    $[55] = t32;
    $[56] = t33;
    $[57] = t34;
    $[58] = t35;
    $[59] = t36;
    $[60] = t37;
  } else {
    t30 = $[53];
    t31 = $[54];
    t32 = $[55];
    t33 = $[56];
    t34 = $[57];
    t35 = $[58];
    t36 = $[59];
    t37 = $[60];
  }
  let t38;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <filter id="cvShadow" x="17" y="7" width="68" height="88" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"><feFlood floodOpacity="0" result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset dx="1" dy="1" /><feGaussianBlur stdDeviation="3" /><feComposite in2="hardAlpha" operator="out" /><feColorMatrix type="matrix" values="0 0 0 0 0.490196 0 0 0 0 0.537255 0 0 0 0 0.588235 0 0 0 0.25 0" /><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_7116" /><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_253_7116" result="shape" /></filter>;
    $[61] = t38;
  } else {
    t38 = $[61];
  }
  const t39 = animate ? "#D2D6D9" : "#7D8996";
  let t40;
  if ($[62] !== animate) {
    t40 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="2300ms" repeatCount="1" fill="freeze" />;
    $[62] = animate;
    $[63] = t40;
  } else {
    t40 = $[63];
  }
  let t41;
  if ($[64] !== t39 || $[65] !== t40) {
    t41 = <stop stopColor={t39}>{t40}</stop>;
    $[64] = t39;
    $[65] = t40;
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  let t42;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />;
    $[67] = t42;
  } else {
    t42 = $[67];
  }
  let t43;
  if ($[68] !== t41) {
    t43 = <linearGradient id="rect1" x1="47" y1="17" x2="68.3198" y2="18.5228" gradientUnits="userSpaceOnUse">{t41}{t42}</linearGradient>;
    $[68] = t41;
    $[69] = t43;
  } else {
    t43 = $[69];
  }
  const t44 = animate ? "#D2D6D9" : "#7D8996";
  let t45;
  if ($[70] !== animate) {
    t45 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="2300ms" repeatCount="1" fill="freeze" />;
    $[70] = animate;
    $[71] = t45;
  } else {
    t45 = $[71];
  }
  let t46;
  if ($[72] !== t44 || $[73] !== t45) {
    t46 = <stop stopColor={t44} stopOpacity="0.8">{t45}</stop>;
    $[72] = t44;
    $[73] = t45;
    $[74] = t46;
  } else {
    t46 = $[74];
  }
  let t47;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />;
    $[75] = t47;
  } else {
    t47 = $[75];
  }
  let t48;
  if ($[76] !== t46) {
    t48 = <linearGradient id="rect2" x1="47" y1="22" x2="87.5569" y2="27.5869" gradientUnits="userSpaceOnUse">{t46}{t47}</linearGradient>;
    $[76] = t46;
    $[77] = t48;
  } else {
    t48 = $[77];
  }
  const t49 = animate ? "#D2D6D9" : "#7D8996";
  let t50;
  if ($[78] !== animate) {
    t50 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="2300ms" repeatCount="1" fill="freeze" />;
    $[78] = animate;
    $[79] = t50;
  } else {
    t50 = $[79];
  }
  let t51;
  if ($[80] !== t49 || $[81] !== t50) {
    t51 = <stop stopColor={t49} stopOpacity="0.8">{t50}</stop>;
    $[80] = t49;
    $[81] = t50;
    $[82] = t51;
  } else {
    t51 = $[82];
  }
  let t52;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />;
    $[83] = t52;
  } else {
    t52 = $[83];
  }
  let t53;
  if ($[84] !== t51) {
    t53 = <linearGradient id="rect3" x1="47" y1="27" x2="84.6527" y2="31.8026" gradientUnits="userSpaceOnUse">{t51}{t52}</linearGradient>;
    $[84] = t51;
    $[85] = t53;
  } else {
    t53 = $[85];
  }
  const t54 = animate ? "#D2D6D9" : "#7D8996";
  let t55;
  if ($[86] !== animate) {
    t55 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="2600ms" repeatCount="1" fill="freeze" />;
    $[86] = animate;
    $[87] = t55;
  } else {
    t55 = $[87];
  }
  let t56;
  if ($[88] !== t54 || $[89] !== t55) {
    t56 = <stop stopColor={t54} stopOpacity="0.8">{t55}</stop>;
    $[88] = t54;
    $[89] = t55;
    $[90] = t56;
  } else {
    t56 = $[90];
  }
  let t57;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />;
    $[91] = t57;
  } else {
    t57 = $[91];
  }
  let t58;
  if ($[92] !== t56) {
    t58 = <linearGradient id="rect4" x1="34" y1="37" x2="94.1118" y2="45.1785" gradientUnits="userSpaceOnUse">{t56}{t57}</linearGradient>;
    $[92] = t56;
    $[93] = t58;
  } else {
    t58 = $[93];
  }
  const t59 = animate ? "#D2D6D9" : "#7D8996";
  let t60;
  if ($[94] !== animate) {
    t60 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="2600ms" repeatCount="1" fill="freeze" />;
    $[94] = animate;
    $[95] = t60;
  } else {
    t60 = $[95];
  }
  let t61;
  if ($[96] !== t59 || $[97] !== t60) {
    t61 = <stop stopColor={t59} stopOpacity="0.8">{t60}</stop>;
    $[96] = t59;
    $[97] = t60;
    $[98] = t61;
  } else {
    t61 = $[98];
  }
  let t62;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />;
    $[99] = t62;
  } else {
    t62 = $[99];
  }
  let t63;
  if ($[100] !== t61) {
    t63 = <linearGradient id="rect5" x1="34" y1="45" x2="94.1118" y2="53.1785" gradientUnits="userSpaceOnUse">{t61}{t62}</linearGradient>;
    $[100] = t61;
    $[101] = t63;
  } else {
    t63 = $[101];
  }
  const t64 = animate ? "#D2D6D9" : "#7D8996";
  let t65;
  if ($[102] !== animate) {
    t65 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="2600ms" repeatCount="1" fill="freeze" />;
    $[102] = animate;
    $[103] = t65;
  } else {
    t65 = $[103];
  }
  let t66;
  if ($[104] !== t64 || $[105] !== t65) {
    t66 = <stop stopColor={t64} stopOpacity="0.8">{t65}</stop>;
    $[104] = t64;
    $[105] = t65;
    $[106] = t66;
  } else {
    t66 = $[106];
  }
  let t67;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />;
    $[107] = t67;
  } else {
    t67 = $[107];
  }
  let t68;
  if ($[108] !== t66) {
    t68 = <linearGradient id="rect6" x1="34" y1="53" x2="94.1118" y2="61.1785" gradientUnits="userSpaceOnUse">{t66}{t67}</linearGradient>;
    $[108] = t66;
    $[109] = t68;
  } else {
    t68 = $[109];
  }
  const t69 = animate ? "#D2D6D9" : "#7D8996";
  let t70;
  if ($[110] !== animate) {
    t70 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="3200ms" repeatCount="1" fill="freeze" />;
    $[110] = animate;
    $[111] = t70;
  } else {
    t70 = $[111];
  }
  let t71;
  if ($[112] !== t69 || $[113] !== t70) {
    t71 = <stop stopColor={t69} stopOpacity="0.8">{t70}</stop>;
    $[112] = t69;
    $[113] = t70;
    $[114] = t71;
  } else {
    t71 = $[114];
  }
  let t72;
  if ($[115] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />;
    $[115] = t72;
  } else {
    t72 = $[115];
  }
  let t73;
  if ($[116] !== t71) {
    t73 = <linearGradient id="rect7" x1="26" y1="63" x2="98.983" y2="68.9578" gradientUnits="userSpaceOnUse">{t71}{t72}</linearGradient>;
    $[116] = t71;
    $[117] = t73;
  } else {
    t73 = $[117];
  }
  const t74 = animate ? "#D2D6D9" : "#7D8996";
  let t75;
  if ($[118] !== animate) {
    t75 = animate && <animate attributeName="stop-color" values="#D2D6D9; #7D8996" dur="300ms" begin="3200ms" repeatCount="1" fill="freeze" />;
    $[118] = animate;
    $[119] = t75;
  } else {
    t75 = $[119];
  }
  let t76;
  if ($[120] !== t74 || $[121] !== t75) {
    t76 = <stop stopColor={t74} stopOpacity="0.8">{t75}</stop>;
    $[120] = t74;
    $[121] = t75;
    $[122] = t76;
  } else {
    t76 = $[122];
  }
  let t77;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <stop offset="1" stopColor="#D9D9D9" stopOpacity="1" />;
    $[123] = t77;
  } else {
    t77 = $[123];
  }
  let t78;
  if ($[124] !== t76) {
    t78 = <linearGradient id="rect8" x1="26" y1="77" x2="97.5619" y2="88.6836" gradientUnits="userSpaceOnUse">{t76}{t77}</linearGradient>;
    $[124] = t76;
    $[125] = t78;
  } else {
    t78 = $[125];
  }
  let t79;
  if ($[126] !== t43 || $[127] !== t48 || $[128] !== t53 || $[129] !== t58 || $[130] !== t63 || $[131] !== t68 || $[132] !== t73 || $[133] !== t78) {
    t79 = <defs>{t38}{t43}{t48}{t53}{t58}{t63}{t68}{t73}{t78}</defs>;
    $[126] = t43;
    $[127] = t48;
    $[128] = t53;
    $[129] = t58;
    $[130] = t63;
    $[131] = t68;
    $[132] = t73;
    $[133] = t78;
    $[134] = t79;
  } else {
    t79 = $[134];
  }
  let t80;
  if ($[135] !== t11 || $[136] !== t15 || $[137] !== t18 || $[138] !== t22 || $[139] !== t25 || $[140] !== t29 || $[141] !== t4 || $[142] !== t6 || $[143] !== t79 || $[144] !== t8) {
    t80 = <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">{t1}{t4}{t6}{t8}{t11}{t15}{t18}{t22}{t25}{t29}{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t79}</svg>;
    $[135] = t11;
    $[136] = t15;
    $[137] = t18;
    $[138] = t22;
    $[139] = t25;
    $[140] = t29;
    $[141] = t4;
    $[142] = t6;
    $[143] = t79;
    $[144] = t8;
    $[145] = t80;
  } else {
    t80 = $[145];
  }
  return t80;
}
export default React.memo(CvParsingIcon);